import MobileFilterSheet from "../../ui/MobileFilterSheet";
import { logTargetLabel } from "./logTargetNames";

function SheetDetailRow({ label, value }) {
  return (
    <div className="flex justify-between gap-4 py-1 text-sm">
      <span className="text-laranjinha/60">{label}</span>
      <span className="text-right font-medium text-laranjinha">{value ?? "-"}</span>
    </div>
  );
}

function formatFieldValue(value) {
  if (value === true) return "✔";
  if (value === false) return "X";
  return value ?? "-";
}

export function MobileLogDetailSheet({ open, onClose, log }) {
  if (!log) {
    return null;
  }

  const fieldEntries = Object.entries(log.fields ?? {});

  return (
    <MobileFilterSheet open={open} onClose={onClose} title="Detalhe do log">
      <div className="space-y-4">
        <div className="rounded-lg border border-primary/30 p-3">
          <SheetDetailRow label="ID" value={log._id} />
          <SheetDetailRow label="Alvo" value={logTargetLabel(log.target)} />
          <SheetDetailRow label="ID do alvo" value={log.targetId} />
          <SheetDetailRow label="Usuário" value={log.user?.email} />
        </div>

        {log.details ? (
          <p className="rounded-lg border border-primary/30 p-3 text-sm text-laranjinha">
            {log.details}
          </p>
        ) : null}

        {fieldEntries.length > 0 ? (
          <div>
            <h3 className="mb-2 text-center text-sm font-semibold text-primary">
              Campos alterados
            </h3>
            <div className="space-y-2">
              {fieldEntries.map(([field, change]) => (
                <div
                  key={field}
                  className="rounded-lg border border-primary/30 p-3 text-sm"
                >
                  <p className="font-medium text-laranjinha">{field}</p>
                  <div className="mt-1 flex justify-between gap-4 text-laranjinha/70">
                    <span>Antes: {formatFieldValue(change?.prev)}</span>
                    <span>Depois: {formatFieldValue(change?.after)}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : null}

        <button
          type="button"
          onClick={onClose}
          className="inline-flex min-h-[44px] w-full items-center justify-center rounded-lg bg-red-700 px-4 font-medium text-white hover:bg-red-800"
        >
          Fechar
        </button>
      </div>
    </MobileFilterSheet>
  );
}
